import { MglMarker, MglPopup, MglNavigationControl, MglGeolocateControl } from '@advisr/v-mapbox';
import MapsMixin from '@/components/core/mapsMixin';
import { mapState } from 'vuex';
const mapHeaderZoom = 12;
export default {
  name: 'CoreDtwinMapHeaderMap',
  components: {
    MglMarker,
    MglPopup,
    MglNavigationControl,
    MglGeolocateControl
  },
  mixins: [MapsMixin],
  props: {
    favorite: {
      type: Boolean,
      required: false,
      default: false
    },
    spectrum: {
      type: Boolean,
      required: false,
      default: () => true
    },
    preview: {
      type: Boolean,
      required: false,
      default: false
    },
    header: {
      type: Boolean,
      required: false,
      default: false
    },
    dtwTitle: {
      type: String,
      required: false,
      default: ''
    },
    interactiveMap: {
      type: Boolean,
      required: false,
      default: false
    },
    fullScreenMap: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapState('app', ['color']),
    subTitle() {
      return this.get(this, 'dtwData.address.formatted_address');
    },
    classObject() {
      if (this.preview && this.favorite) {
        return 'favoriteMap';
      } else if (this.preview) {
        return 'previewHeaderMap';
      } else if (this.fullScreenMap) {
        return 'headerMapFullScreen';
      }
      return 'headerMap';
    },
    markerCoordinates() {
      return this.allowMultiCoordinates ? this.geoCoordinates[0].coordinates : this.geoCoordinates;
    },
    centerCoordinates() {
      if (this.favorite) {
        // move map a bit down so the icon is not underneath the address label
        return [this.markerCoordinates[0], this.markerCoordinates[1] + 0.0006];
      }
      return this.markerCoordinates;
    }
  },
  created() {
    this.map = null;
    this.zoomToUseFallback = mapHeaderZoom;
    this.zoomOffset = -1.5;
  },
  methods: {
    onMapLoaded(event) {
      this.map = event.map;
      this.drawOverlay();
      const zoomToUse = this.calculateZoomToUse();
      if (!this.allowScrollZoom) {
        this.map.scrollZoom.disable();
      } else {
        this.map.scrollZoom.enable();
      }
      this.addToAnimationQueue({
        center: this.centerCoordinates,
        pitch: 0,
        bearing: 0,
        zoom: zoomToUse,
        duration: this.animateFlyIn ? 2000 : 0,
        animate: this.animateFlyIn
      });
    },
    drawOverlay() {
      if (!this.map) {
        return;
      }
      if (!this.map.getSource('empty')) {
        // since there is no direct z-index property, create dummy layers under which stuff is positioned
        // drawOverlay should be called before any draw-controls for polygons are added,
        // as to make sure this is really at the bottom
        this.map.addSource('empty', {
          type: 'geojson',
          data: {
            type: 'FeatureCollection',
            features: []
          }
        });
        this.map.addLayer({
          id: 'groundLayer',
          type: 'symbol',
          source: 'empty'
        });
      }
      const overlayId = 'overlay';
      if (this.map.getLayer(overlayId)) {
        this.map.removeLayer(overlayId);
      }
      if (this.map.getSource(overlayId)) {
        this.map.removeSource(overlayId);
      }
      if (!this.overlayInfo) {
        return;
      }
      this.map.addSource(overlayId, {
        type: 'image',
        url: this.overlayInfo.image,
        coordinates: this.overlayInfo.coordinates
      });
      this.map.addLayer({
        id: overlayId,
        source: overlayId,
        type: 'raster',
        paint: {
          'raster-opacity': 1.0
        }
      }, 'groundLayer');
    }
  }
};